const leftPad = (string, chars, hasPrefix,sign) => {
    //var hasPrefix = /^0x/i.test(string) || typeof string === 'number';
    string = string.toString(16).replace(/^0x/i,'');

    var padding = (chars - string.length + 1 >= 0) ? chars - string.length + 1 : 0;

    return (hasPrefix ? '0x' : '') + new Array(padding).join(sign ? sign : "0") + string;
};
function isHexString(value, length) {
    if (typeof (value) !== 'string' || !value.match(/^0x[0-9A-Fa-f]*$/)) {
      return false
    }
    if (length && value.length !== 2 + 2 * length) { return false; }
    return true;
  }
  
function isArrayish(value) {
    if (!value || parseInt(value.length) != value.length || typeof (value) === 'string') {
      return false;
    }
  
    for (var i = 0; i < value.length; i++) {
      var v = value[i];
      if (v < 0 || v >= 256 || parseInt(v) != v) {
        return false;
      }
    }
  
    return true;
  }
  function addSlice(array) {
    if (array.slice) { return array }
  
    array.slice = function () {
      const args = Array.prototype.slice.call(arguments)
      return new Uint8Array(Array.prototype.slice.apply(array, args))
    }
  
    return array
  }
  
function arrayify(value) {
    if (value == null) {
      // errors.throwError('cannot convert null value to array', errors.INVALID_ARGUMENT, { arg: 'value', value: value });
    }
  
    if (value && value.toHexString) {
      value = value.toHexString();
    }
  
    if (isHexString(value)) {
      value = value.substring(2);
      if (value.length % 2) { value = '0' + value; }
  
      var result = [];
      for (var i = 0; i < value.length; i += 2) {
        result.push(parseInt(value.substr(i, 2), 16));
      }
  
      return addSlice(new Uint8Array(result));
  
    } else if (typeof (value) === 'string') {
      if (value.match(/^[0-9a-fA-F]*$/)) {
        // errors.throwError('hex string must have 0x prefix', errors.INVALID_ARGUMENT, { arg: 'value', value: value });
      }
      // errors.throwError('invalid hexidecimal string', errors.INVALID_ARGUMENT, { arg: 'value', value: value });
    }
  
    if (isArrayish(value)) {
      return addSlice(new Uint8Array(value));
    }
  
    // errors.throwError('invalid arrayify value', { arg: 'value', value: value, type: typeof (value) });
  }

  function buf2hex(buffer) { // buffer is an ArrayBuffer
    return Array.prototype.map.call(new Uint8Array(buffer), x => ('00' + x.toString(16)).slice(-2)).join('');
  }
export { leftPad,arrayify,buf2hex }
